import { defineComponent as _defineComponent } from 'vue'
import { Message } from 'element-ui'
import { PropType, computed, nextTick, ref } from 'vue'

import { ColumnType } from '../util/types'

type AlignType = 'left' | 'right' | 'center'


export default /*#__PURE__*/_defineComponent({
  __name: 'inputTable',
  props: {
  data: {
    type: Array as PropType<any[]>,
    required: true,
  },
  columns: {
    type: Array as PropType<ColumnType[]>,
    required: true,
  },
  align: {
    type: String as PropType<AlignType>,
    required: false,
    default: 'left',
  },
  border: {
    type: Boolean,
    required: false,
    default: false,
  },
  width: {
    type: String,
    required: false,
    default: '100%',
  },
},
  setup(__props) {

const props = __props



const tableData = computed(() => props.data)

const rowIndex = ref(-1)
const columnIndex = ref(-1)
const currentRow = ref<any>()
// 记录当前刀具编号名
const copyKnifeId = ref(-1)
const copyKnifeName = ref('')

// 是否具有空编号刀具
const hasEmptyID = ref<boolean>(false)

const editInputRef = ref()

// 更改单元格样式
function columnStyle({ row, column }: any) {
  if (column.property === 'id') {
    row
    return 'padding-left: 16px;'
  }
}
// 更改行样式
function changeStyle({ row, rowIndex }: any) {
  row
  if (currentRow.value?.index == rowIndex) {
    return {
      height: '54px',
      'border-top': '1px solid #EEEEEE',
      'font-size': '14px',
      color: '#000000',
      'font-weight': '400',
      background: 'rgba(24, 168, 199, 0.2)',
    }
  }
  return {
    height: '54px',
    'border-top': '1px solid #EEEEEE',
    'font-size': '14px',
    color: '#000000',
    'font-weight': '400',
  }
}
// 更改表头单元格样式
function headerStyle({ column }: any) {
  if (column.property === 'id') {
    return 'box-sizing: border-box;background: #fafafa;'
  }
  return 'background: #fafafa'
}
// 更改表头行样式
function headerRowStyle() {
  return {
    height: '54px',
    'font-size': '14px',
    color: '#000000',
    'font-weight': '500',
    'border-bottom': 'none',
  }
}
// 点击单元格切换成输入框
function cellClick(row: any, column: any) {
  if (!hasEmptyID.value) {
    rowIndex.value = row.index
    columnIndex.value = column.index
    nextTick(() => {
      editInputRef.value && editInputRef.value[0]?.focus()
    })
  } else {
    columnIndex.value = 0
  }
}
function tableRowClassName({ row, rowIndex }: any) {
  row.index = rowIndex
}
//把每一列的索引加到列数据中
function tableCellClassName({ column, columnIndex }: any) {
  column.index = columnIndex
}
// 选择行
function choseKnife(row: any) {
  currentRow.value = row
}

function inputBlur(e: any, i: number, cellIndex: number, col: any) {
  if (col.props === 'moveSpeed' || col.props === 'doSpeed') {
    e[col.props] = e[col.props].replace(/\.$/g, '') //不能以小数点结尾
    // 判断当前最后一个字符串不可能为小数点
    // if (e[col.props]?.endswith('.') || e[col.props]?.endswith('-'))
    if (
      e[col.props].substr(e[col.props].length - 1, 1) === '.' ||
      e[col.props].substr(e[col.props].length - 1, 1) === '-'
    ) {
      e[col.props] = e[col.props].substring(0, 1)
    }
  }
  if (!e.knifeName && !e.id) {
    Message({
      message: '请输入刀具编号',
      duration: 1500,
      type: 'warning',
    })
    hasEmptyID.value = true
  } else {
    hasEmptyID.value = false
    // 查询刀具编号是否重复，重复清空
    if (!cellIndex) {
      let saveKnifeId: any[] = []
      tableData.value.forEach((item, index) => {
        if (i != index) {
          saveKnifeId.push(item.id)
          saveKnifeId.push(item.knifeName)
        }
      })
      saveKnifeId = saveKnifeId.filter((item) => item)
      if (saveKnifeId.indexOf(e.knifeName) != -1) {
        Message({
          message: '编号重复，请重新设置',
          duration: 1000,
        })
        hasEmptyID.value = true
        tableData.value[i].id = copyKnifeId.value
        tableData.value[i].knifeName = copyKnifeName.value
      }
    }
  }

  if (!hasEmptyID.value) {
    rowIndex.value = -1
    columnIndex.value = -1
  }
}

function getNowKnifeName(id: any, cellIndex: number) {
  if (!cellIndex) {
    copyKnifeId.value = id
    copyKnifeName.value = id
  }
}
function inputCheck(row: any, col: any) {
  if (columnIndex.value == 1) {
    row[col.props] = row[col.props]
      .replace(/^[^\d]/) // 第一个字符只能输入负号或数字
      .replace(/[^\d.|-]/g, '') // 去除数字和小数点以外的数字
      .replace(/-{1,}/g, '') // 去除多余的负号
      .replace(/-/, '#$#') // 将负号暂存为其他字符
      .replace(/-/g, '') // 替换多余的负号, 防止输入时的闪烁
      .replace('#$#', '-') // 替换完成之后将暂存负号替换回来
      .replace(/\.{2,}/g, '.') // 去除多余小数点
      .replace('.', '@@@') // 将小数点暂存为其他字符
      .replace(/\./g, '') // 替换多余的小数点, 防止输入时的闪烁
      .replace('@@@', '.') // 将暂存的小数点替换回来
  } else if (col.isInputCheck) {
    // 此处定义快速进给速度和加工速度的输入限制 速度为保留一位小数的实数
    row[col.props] = row[col.props]
      .replace(/^[^\-|^\d]/) // 第一个字符只能输入负号或数字
      .replace(/[^\d.|-]/g, '') // 去除数字和小数点以外的数字
      .replace(/\|{1,}/g, '') //去除字符中的竖线|
      .replace(/-{2,}/g, '') // 去除多余的负号
      .replace(/-/, '#$#') // 将负号暂存为其他字符
      .replace(/-/g, '') // 替换多余的负号, 防止输入时的闪烁
      .replace('#$#', '-') // 替换完成之后将暂存负号替换回来
      .replace(/\.{2,}/g, '.') // 去除多余小数点
      .replace('.', '@@@') // 将小数点暂存为其他字符
      .replace(/\./g, '') // 替换多余的小数点, 防止输入时的闪烁
      .replace('@@@', '.') // 将暂存的小数点替换回来
      .replace(/^(-)*(\d+)\.(\d).*$/, '$1$2.$3') //保留一位小数

    if (row[col.props].indexOf('-') > 0) {
      row[col.props] = row[col.props].split('-').join('')
    }
  }
}

function handleAdd() {
  let row: { [key: string]: any } = {}
  props.columns.forEach((column) => {
    row[column.props] = ''
  })
  row.knifeName = `T${tableData.value.length + 1}`
  tableData.value.push(row)
  cellClick({ index: tableData.value.length - 1 }, { index: 0 })
}

function handleDelete() {
  tableData.value.pop()
}

return { __sfc: true,props, tableData, rowIndex, columnIndex, currentRow, copyKnifeId, copyKnifeName, hasEmptyID, editInputRef, columnStyle, changeStyle, headerStyle, headerRowStyle, cellClick, tableRowClassName, tableCellClassName, choseKnife, inputBlur, getNowKnifeName, inputCheck, handleAdd, handleDelete }
}

})